const services = [
 {
    id: "home-icu-setup",
    title: "Home ICU Setup",
    highlight: "Critical Care at Home",
    desc:
      "Our Home ICU Setup service brings hospital-level critical care directly to the patient’s home. We provide ICU beds, ventilators, monitors, oxygen support, and 24/7 trained medical staff to ensure continuous and safe treatment in a familiar environment.",
    image: "/ICU-Equipment.jpg",
    buttonLabel: "Explore Home ICU",
  },
  // ✅ New Service: Physiotherapy at Home
  {
    id: "physiotherapy-at-home",
    title: "Physiotherapy at Home",
    highlight: "Recovery with Comfort",
    desc:
      "Our Physiotherapy at Home service helps patients recover faster through personalized exercise programs. Certified physiotherapists provide pain management, mobility improvement, and post-surgery rehabilitation without the need to travel.",
    image: "/Disability-Care.webp",
    buttonLabel: "Learn About Physiotherapy",
  },
  
  {
    id: "home-doctor-visits",
    title: "Home Doctor Visits",
    highlight: "Certified Doctors at Your Doorstep",
    desc:
      "We provide experienced and qualified doctors directly at your home, ensuring timely diagnosis, regular follow-ups, and stress-free treatment for senior citizens and chronic patients.",
    image: "/DSC_2683-Edit-2WEB-3.webp",
    buttonLabel: "Doctor Visit",
  },
  {
    id: "trained-nursing-care",
    title: "Trained Nursing Care",
    highlight: "24x7 Professional Nursing Support",
    desc:
      "Our trained nurses assist patients with daily medical needs, injections, wound care, monitoring vitals, and long-term care for elderly patients at home.",
    image: "/Revolutionizing-Elderly-Care_-Doctor-Home-Visits-1.png",
    buttonLabel: "Nursing Care",
  },
  {
    id: "medical-equipment-at-home",
    title: "Medical Equipment at Home",
    highlight: "Hospital-Grade Equipment at Home",
    desc:
      "We arrange oxygen concentrators, hospital beds, wheelchairs, nebulizers, and other essential medical equipment directly at your home.",
    image: "/home-doctor-visit-1.webp",
    buttonLabel: "Equipment",
  },
  {
    id: "elderly-chronic-care",
    title: "Elderly & Chronic Care",
    highlight: "Specialized Senior Citizen Care",
    desc:
      "Dedicated long-term care plans for elderly patients, ensuring comfort, safety, emotional support, and continuous medical supervision.",
    image: "/side-view-woman-with-medical-mask-taking-care-elder-woman-home_23-2148492360.jpg",
    buttonLabel: "Senior Care",
  },
  {
    id: "complete-home-healthcare",
    title: "Complete Home Healthcare",
    highlight: "Trusted by Thousands of Families",
    desc:
      "HomoDial Healthcare Solution Pvt. Ltd. is a trusted name for complete home-based healthcare services with personalized care plans.",
    image: "/istockphoto-1719539154-612x612.jpg",
    buttonLabel: "Full Care",
  }
];

export default services;
